import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

/* Actions */
import {
	getOrderDetails,
	getOrderList,
	saveManageOrdersListBackup,
	saveOrderShippingDetails,
} from '../../../redux/actions';

class UpdateBookedOrderConfirmationError extends Component {

	componentWillMount() {
		window.scrollTo(0, 0);
		if(this.props.state.order.updateBookedOrderConfirmationPageData) {
			this.setState({
				updateBookedOrderConfirmationPageData: this.props.state.order.updateBookedOrderConfirmationPageData
			});
		} else {
			browserHistory.push('/manageorders');
		}
	}

	handleReturnToPreviousPage(e) {
		e.preventDefault();
		const self = this;
		const {
			updateBookedOrderConfirmationPageData: {
				orderNumber
			}
		} = self.state;
		self.props.getOrderList(`accountNumber=${self.props.getSelectedAccountNumber()}&requestType=manageOrders&orderNumber=${orderNumber}&poNumber=&referenceNumber=`, response => {
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				})
			} else {
				const manageOrdersListBackup = JSON.parse(JSON.stringify(self.props.state.order.manageOrdersListBackup));
				// update backed up manage order with updated order list which will be having updated data after updating booked orders
				const data = response.responseObject[0];
				const finalData = [];
				manageOrdersListBackup.ordersListResponse.responseObject.forEach(itm => {
					if(itm.orderHeader.orderNumber === self.state.updateBookedOrderConfirmationPageData.orderNumber) {
						finalData.push(data);
					} else {
						finalData.push(itm);
					}
				});
				manageOrdersListBackup.ordersListResponse.responseObject = JSON.parse(JSON.stringify(finalData));
				manageOrdersListBackup.backupOrdersListResponse.responseObject = JSON.parse(JSON.stringify(finalData));
				//Save manage order list into store
				self.props.saveManageOrdersListBackup(JSON.parse(JSON.stringify(manageOrdersListBackup)));
				browserHistory.push('/manageorders');
			}
		});
	}

	handleFetchOrderDetails(orderNumber, wheretoRedirect, event) {
		event.preventDefault();
		const self = this;
		self.props.saveOrderShippingDetails(null);
		self.props.getOrderDetails('orderNumber='+orderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
			if(!response.status || !response.responseObject) {
				self.setState({
					errorMessage: response.responseMessage
				})
			} else {
				browserHistory.push('/' + wheretoRedirect);
			}
		});
	}

    render() {
		const { updateBookedOrderConfirmationPageData } = this.state;
		let holdBackorderItem = [];
		let splitDeliveryItem = [];
		const { holdServiceFailed = false, orderNumber = '', splitDeliveryServiceFailed = false } = updateBookedOrderConfirmationPageData;
		// let updatedItems = [];
		if(updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.items) {
			holdBackorderItem = updateBookedOrderConfirmationPageData.items.filter(item => item.action === 'Hold Backorder');
		}
		if(updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.items) {
			splitDeliveryItem = updateBookedOrderConfirmationPageData.items.filter(item => item.action === 'Split Delivery');
		}
		let isFailedToFetch = false;
		if (updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.updateBookedOrderErrorOccured &&
			updateBookedOrderConfirmationPageData.updateBookedOrderErrorOccured.find(item => item === 'Failed to fetch')
		) {
			isFailedToFetch = true;
		}
        return (
			<div>
				<h1 className="pageTitle">Update Order Confirmation</h1>
				{isFailedToFetch
					? <div>
						<p className="red bold">An error may have occurred saving your changes. Please review the order and contact Order Management if you have questions.</p>
						<p className="red bold">{updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.updateBookedOrderErrorOccured}</p>
					</div>
					: <p className="red bold">
						Changes to this order have been submitted. Please check back after an hour to verify that all updates have been saved. If you have questions, please contact the CustomerNet Help Desk at 1-800-242-1333.
					</p>
				}
				{holdServiceFailed
					? <p className="red">
						Please allow some time for changes to be reflected on the original order {orderNumber}. For very large orders, this could take up to an hour. Resubmitting the changes is not necessary.
					</p>
					:<div>
						{!holdServiceFailed && holdBackorderItem && holdBackorderItem.length > 0 &&
							<p className="bold red" style={{marginBottom: 0}}>
								The following products have been moved to a Backorder Hold on Reference #{updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.createOrderResponse && updateBookedOrderConfirmationPageData.createOrderResponse.orderNumber}
							</p>
						}
						{!holdServiceFailed && holdBackorderItem && holdBackorderItem.length > 0 &&<div>
							<table className="dataTable manageOrdersDeleteProductsRptTable" width="100%">
								<thead>
									<tr>
										<th className="delProd">Product</th>
										<th className="delProdDesc">Description</th>
										<th className="delProdQuantity">Quantity</th>
									</tr>
								</thead>
								<tbody>
									{holdBackorderItem.map((item, index) => {
										return [<tr key={index}>
											<td className="delProd">{item.item}</td>
											<td className="delProdDesc">{item.itemDescription}</td>
											<td className="delProdQuantity">{item.quantity}</td>
										</tr>,
										item.relatedServices ? item.relatedServices.map((item, index) => {
											return <tr key={index}>
												<td className="delProd"> &nbsp; &nbsp; {item.serviceId}</td>
												<td className="delProdDesc">{item.serviceName}</td>
												<td className="delProdQuantity">{item.quantity}</td>
											</tr>
										})
										:null
										]
									})}
								</tbody>
							</table>
						</div>}
					</div>
				}
				{splitDeliveryServiceFailed
					? <p className="red">
						Please allow some time for changes to be reflected on the original order {orderNumber}. For very large orders, this could take up to an hour. Resubmitting the changes is not necessary.
					</p>
					:<div>
						{!splitDeliveryServiceFailed && splitDeliveryItem && splitDeliveryItem.length > 0 &&
							<p className="bold red" style={{marginBottom: 0}}>
								The following products have been moved to a new order on Reference #{updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.createOrderResponse && updateBookedOrderConfirmationPageData.createOrderResponse.orderNumber}
							</p>
						}
						{!splitDeliveryServiceFailed && splitDeliveryItem && splitDeliveryItem.length > 0 &&<div>
							<table className="dataTable manageOrdersDeleteProductsRptTable" width="100%">
								<thead>
									<tr>
										<th className="delProd">Product</th>
										<th className="delProdDesc">Description</th>
										<th className="delProdQuantity">Quantity</th>
									</tr>
								</thead>
								<tbody>
									{splitDeliveryItem.map((item, index) => {
										return [<tr key={index}>
											<td className="delProd">{item.item}</td>
											<td className="delProdDesc">{item.itemDescription}</td>
											<td className="delProdQuantity">{item.quantity}</td>
										</tr>,
										item.relatedServices ? item.relatedServices.map((item, index) => {
											return <tr key={index}>
												<td className="delProd"> &nbsp; &nbsp; {item.serviceId}</td>
												<td className="delProdDesc">{item.serviceName}</td>
												<td className="delProdQuantity">{item.quantity}</td>
											</tr>
										})
										:null
										]
									})}
								</tbody>
							</table>
						</div>}
					</div>
				}
				<p><a href="" onClick={this.handleFetchOrderDetails.bind(this, updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.orderNumber, 'orderdetails')}>View order details {updateBookedOrderConfirmationPageData && updateBookedOrderConfirmationPageData.orderNumber}</a></p>
				<div>
                   	<p><a href="" onClick={this.handleReturnToPreviousPage.bind(this)}>Return to Previous Screen</a></p>
					<div className="clear" />
             	</div>
	      	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderDetails: (queryStringParams, callback) => dispatch(getOrderDetails(queryStringParams, callback)),
	getOrderList: (queryStringParams, callback) => dispatch(getOrderList(queryStringParams, callback)),
	saveManageOrdersListBackup: (data) => dispatch(saveManageOrdersListBackup(data)),
	saveOrderShippingDetails: (data) => dispatch(saveOrderShippingDetails(data)),
})

UpdateBookedOrderConfirmationError = connect(mapStateToProps, mapDispatchToProps)(UpdateBookedOrderConfirmationError);
export default UpdateBookedOrderConfirmationError;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/updateBookedOrderConfirmationError.js